import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import TableRows from "./tableRows";
import AddressInfoTable from "./addressInfoTable";

const AdressInfo = ({ order }) => {
  return (
    <Box>
      <Typography sx={{ fontWeight: 500 }} textAlign={"center"} mb={2}>
        Adresseoplysninger
      </Typography>

      <TableContainer
        variant={"Paper"}
        sx={{ mb: 5, boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)" }}
      >
        <Table aria-label="simple table">
          <TableBody>
            <AddressInfoTable partName={"Kunde"} order={order} />
            <AddressInfoTable partName={"Leveringsadresse"} order={order} />
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AdressInfo;
